import request from '@/utils/request'

export function getBanner (params) {
  return request({
    url: '/poker-api/website/getBanner',
    // url: '/',
    method: 'post',
    params
  })
}

export function getNewsTabList (params) {
  return request({
    url: '/poker-api/website/getNewsTabList',
    // url: '/',
    method: 'post',
    params
  })
}

export function getNewsList (params) {
  return request({
    url: '/poker-api/website/getNewsList',
    // url: '/',
    method: 'post',
    params
  })
}

export function getSocialList (params) {
  return request({
    url: '/poker-api/website/getSocialList',
    // url: '/',
    method: 'post',
    params
  })
}

export function getFestivalBanner (params) {
  return request({
    url: '/poker-api/website/getFestivalBanner',
    // url: '/',
    method: 'post',
    params
  })
}

export function getFestivalPreviewMatch (params) {
  return request({
    url: '/poker-api/website/getFestivalPreviewMatch',
    // url: '/',
    method: 'post',
    params
  })
}

export function getFestivalHistoryMatch (params) {
  return request({
    url: '/poker-api/website/getFestivalHistoryMatch',
    // url: '/',
    method: 'post',
    params
  })
}

export function getBlogTab (params) {
  return request({
    url: '/poker-api/website/getBlogTab',
    // url: '/',
    method: 'post',
    params
  })
}

export function getBlogArticle (params) {
  return request({
    url: '/poker-api/website/getBlogArticle',
    // url: '/',
    method: 'post',
    params
  })
}

export function sendQaReport (params) {
  return request({
    url: '/poker-api/website/sendQaReport',
    // url: '/',
    method: 'post',
    params
  })
}

export function receiveUserEmail (params) {
  return request({
    url: '/poker-api/website/receiveUserEmail',
    // url: '/',
    method: 'post',
    params
  })
}

export function ticketVerify (params) {
  return request({
    url: '/poker-api/ticket/verify',
    // url: '/',
    method: 'post',
    params
  })
}

export function getPlatforms (params) {
  return request({
    url: '/poker-api/get/platforms',
    // url: '/',
    method: 'get',
    params
  })
}

export function ticketRegister (params) {
  return request({
    url: '/poker-api/ticket/register',
    // url: '/',
    method: 'post',
    params
  })
}

export function getIp (params) {
  return request({
    url: '/poker-api/ip/package',
    method: 'get',
    params
  })
}